module.exports = __webpack_public_path__ + "static/media/Article 6.cd722b20.svg";